// routes/_app.me.$.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.me.$')

export const handle = { name: 'me/*' }

export default dynamic(getClientModule, { ssr: false })
